import Area from "./Area";

export default Area;
